module.exports = __webpack_public_path__ + "img/source03_b2.cdf06def.png";